module.exports = __webpack_public_path__ + "img/CMMI.6e00cb52.png";